module.exports = __webpack_public_path__ + "static/media/investors-mob.7d68d4b1.png";